export const cacheKey = "/engagement/global_control_settings" as const;
